<template>
  <div class="pill-bar d-flex flex-wrap">
    <v-chip
      v-for="pill in pills"
      :key="pill.key"
      small
      :color="pill.color"
      :outlined="!isFilled(pill)"
      :text-color="isFilled(pill) ? 'white' : undefined"
      :style="{ opacity: isDimmed(pill) ? 0.55 : 1, cursor: clickable ? 'pointer' : 'default' }"
      class="font-weight-medium mr-2 mb-2"
      @click="clickable && $emit('select', pill.key)"
    >
      <span class="font-weight-bold mr-1">{{ pill.count }}</span>
      {{ pill.label }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "SummaryPillBar",
  props: {
    pills: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: [String, Number],
      default: null,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isFilled(pill) {
      return this.clickable && this.activeKey === pill.key;
    },
    isDimmed(pill) {
      return this.clickable && this.activeKey != null && this.activeKey !== pill.key;
    },
  },
};
</script>

<style scoped>
.pill-bar .v-chip {
  transition: opacity 0.15s ease;
}
</style>
